import { render, staticRenderFns } from "./cModaladdPayOs.vue?vue&type=template&id=081fd5d6&scoped=true"
import script from "./cModaladdPayOs.vue?vue&type=script&lang=js"
export * from "./cModaladdPayOs.vue?vue&type=script&lang=js"
import style0 from "./cModaladdPayOs.vue?vue&type=style&index=0&id=081fd5d6&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "081fd5d6",
  null
  
)

export default component.exports